<script setup lang="ts">
import type { FooterFields } from "@citizenm/foundation/shared/types/contentful";

defineProps<{ legalLinks: FooterFields["legalLinks"] }>();
</script>

<template>
  <div class="legal-links">
    <LayoutLink
      v-for="link in legalLinks"
      :key="link.fields.name"
      size="sm"
      :link="link.fields"
    />
    <LayoutLink
      size="sm"
      :link="{
        title: 'cookie preferences',
        url: '#!',
        nofollow: true,
      }"
      class="ot-sdk-show-settings"
    />
  </div>
</template>

<style scoped lang="scss">
.legal-links {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
</style>
